import { render } from "./Grade.vue?vue&type=template&id=6f8b517a&bindings={\"grade\":\"props\",\"formatGrade\":\"options\"}"
import script from "./Grade.vue?vue&type=script&lang=ts"
export * from "./Grade.vue?vue&type=script&lang=ts"
script.render = render

export default script